<mat-drawer-container>
    <mat-drawer mode="side" opened="true">
        <app-navbar></app-navbar>
    </mat-drawer>   
    <mat-drawer-content>
        <app-header></app-header>
        <div class="dashboard-page-shell">
            <router-outlet></router-outlet>
        </div>
    </mat-drawer-content>
</mat-drawer-container>